// Chat app-setting keys read outside chat-common: node-core's DB restore fakes the spam sender
// list and may import only scope:shared projects.
export enum ChatAppSettingKeyEnum {
  CHAT_SPAM_SENDER_LIST = 'CHAT_SPAM_SENDER_LIST',
}
